import { useQuery } from '@redwoodjs/web';

import {
    GET_APPLICATION,
    GET_APPLICATION_BY_SERVICE_ID,
} from 'src/graphql/queries/merchantApplications.query';

const useMerchantApplication = (serviceId?: number) => {
    const {
        data: idData,
        loading: loadingId,
        error: errorId,
    } = useQuery(GET_APPLICATION_BY_SERVICE_ID, {
        variables: { serviceId },
        skip: !serviceId,
    });

    const applicationId = idData?.getApplicationByServiceId;

    const {
        data: appData,
        loading: loadingApp,
        error: errorApp,
    } = useQuery(GET_APPLICATION, {
        variables: { id: applicationId },
        skip: !applicationId,
    });

    return {
        data: appData?.retrieveMerchantApplication,
        loading: loadingId || loadingApp,
        error: errorId || errorApp,
    };
};

export default useMerchantApplication;
